import React from 'react';
import { Mail, Globe } from 'lucide-react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer data-testid="footer" className="bg-slate-50 border-t border-slate-200">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
          <div className="space-y-5">
            <div className="flex items-center">
              <img src="https://customer-assets.emergentagent.com/job_38ea2e2e-0b2a-4c96-90e7-893185248e11/artifacts/fcaqs56k_logo.png" alt="Guardifix" className="h-8" />
            </div>

            <p className="text-slate-500 text-sm leading-relaxed max-w-sm">
              Enterprise-grade encrypted email built for teams that demand privacy, compliance, and zero compromise on security.
            </p>
          </div>

          <div>
            <h3 className="text-sm font-bold text-slate-900 mb-4 uppercase tracking-wider" style={{ fontFamily: 'Outfit, sans-serif' }}>Contact</h3>
            <ul className="space-y-3">
              <li className="flex items-center gap-2 text-slate-500 text-sm">
                <Mail className="h-4 w-4 text-blue-700" />
                <span data-testid="footer-email">info@guardifix.com</span>
              </li>
              <li className="flex items-center gap-2 text-slate-500 text-sm">
                <Globe className="h-4 w-4 text-blue-700" />
                <span data-testid="footer-website">guardifix.com</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-slate-200 mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-slate-400 text-xs">
              &copy; {new Date().getFullYear()} Guardifix. All rights reserved.
            </p>
            <div className="flex gap-6">
              <Link data-testid="footer-privacy-link" to="/privacy-policy" className="text-slate-400 hover:text-blue-700 transition-colors duration-200 text-xs">
                Privacy Policy
              </Link>
              <Link data-testid="footer-terms-link" to="/terms-of-service" className="text-slate-400 hover:text-blue-700 transition-colors duration-200 text-xs">
                Terms of Service
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
